<div [formGroup]="form">
  <mdb-form-control>
    <mdb-select class="position-relative" [style.width]="width" [filter]="filter" [clearButton]="clearButton" [formControl]="control"
      [notFoundMsg]="notFoundMsg" [placeholder]="placeholder" [disabled]="disabled" [multiple]="multiple"
      (valueChange)="handleChange($event)" [class.is-invalid]="(control?.touched || submitted) && required && control?.errors"
      [required]="required">
      @for (option of data; track option) {
        <mdb-option [value]="getValue(option)" (click)="$event.stopPropagation()">
          {{
          getOption(option)
          }}
        </mdb-option>
      }
    </mdb-select>
  </mdb-form-control>
</div>